import script from "./addPlant.vue?vue&type=script&setup=true&lang=js"
export * from "./addPlant.vue?vue&type=script&setup=true&lang=js"

import "./addPlant.vue?vue&type=style&index=0&id=2d35b87a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d35b87a"]])

export default __exports__